import { getBrand } from "@faire/help-center-utils/serialized-data/getBrand";
export var isBrandInactive = function isBrandInactive() {
  var brand = getBrand();
  return !(brand !== null && brand !== void 0 && brand.active);
};